import * as v from 'valibot';
import { transmitterKindSchema } from '../types/transmitter';
import { nexaCodeSchema, } from '../types/NexaCode';
import { endpointIdSchema, integerInRange } from '../util/valibot';
const nexaTransmitterKindSchema = v.union([v.literal('onoff'), v.literal('dimmer')]);
export function toNexaTransmitterKind(t) {
    switch (t) {
        case 'dim': return 'dimmer';
        case 'onoff': return 'onoff';
        case 'rollershade': throw new Error('TransmitterKind "rollershade" can not be converted to NexaTransmitterKind');
        case 'garage': throw new Error('TransmitterKind "garage" can not be converted to NexaTransmitterKind');
    }
}
export function fromNexaTransmitterKind(t) {
    switch (t) {
        case 'dimmer': return 'dim';
        case 'onoff': return 'onoff';
    }
}
const nexaReceiverKindSchema = v.union([v.literal('onoff'), v.literal('dimmer')]);
export function toNexaReceiverKind(t) {
    switch (t) {
        case 'dim': return 'dimmer';
        case 'onoff': return 'onoff';
        case 'rollershade': throw new Error('TransmitterKind "rollershade" can not be converted to NexaReceiverKind');
        case 'garage': throw new Error('TransmitterKind "garage" can not be converted to NexaReceiverKind');
    }
}
export function fromNexaReceiverKind(t) {
    switch (t) {
        case 'dimmer': return 'dim';
        case 'onoff': return 'onoff';
    }
}
const deviceProtocolSchema = v.variant('name', [
    v.object({
        name: v.literal('zigbee'),
        zigbee_node_id: integerInRange(0, 0xffffffff),
        endpoint_id: endpointIdSchema,
    }),
    v.object({
        name: v.literal('nexa receiver'),
        kind: nexaReceiverKindSchema,
        codes: v.array(nexaCodeSchema),
    }),
    v.object({
        name: v.literal('nexa transmitter'),
        kind: nexaTransmitterKindSchema,
        code: integerInRange(0, 0x3ffffff), // 26 bits
        unit: integerInRange(0, 15),
    }),
    v.object({
        name: v.literal('hasta receiver'),
        codes: v.array(nexaCodeSchema),
    }),
    v.object({
        name: v.literal('hasta transmitter'),
        code: integerInRange(0, 0x3ffffff),
        unit: integerInRange(0, 15),
    }),
    v.object({
        name: v.literal('mandolyn'),
        code: v.string(),
    }),
    v.object({
        name: v.literal('zigbee tuya garage'),
        zigbee_node_id: integerInRange(0, 0xffffffff),
        endpoint_id: endpointIdSchema,
    }),
]);
export const deviceSchema = v.object({
    id: integerInRange(0, 0xffffffff),
    title: v.string(),
    comment: v.string(),
    protocol: deviceProtocolSchema,
    transmitter_kind: v.optional(v.pipe(v.union([transmitterKindSchema, v.literal('')]), v.transform((s) => s == '' ? undefined : s))),
});
